import classnames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  align-content: stretch;
  align-items: center;
  justify-items: center;
  grid-template-areas: 'left center right';
  grid-template-columns: 1fr minmax(0, max-content) 1fr;

  &.hasLeft > :first-child {
    grid-area: left;
    justify-self: start;
  }
  &.hasLeft > :nth-child(2),
  &:not(.hasLeft) > :first-child {
    grid-area: center;
  }
  &.hasRight > :last-child {
    grid-area: right;
    justify-self: end;
  }
`;

type Props = {
  children: ReactNode;
  left?: ReactNode;
  right?: ReactNode;
  style?: CSSProperties;
  className?: string;
};

export const Centered = ({
  children,
  left,
  right,
  style,
  className,
}: Props) => {
  const hasLeft = !!left;
  const hasRight = !!right;
  return (
    <Wrapper
      className={classnames({ hasLeft, hasRight }, className)}
      style={style}
    >
      {left}
      {children}
      {right}
    </Wrapper>
  );
};
